import { render, staticRenderFns } from "./Edit-Profile-Recruiter.vue?vue&type=template&id=6dd12b13&scoped=true&"
import script from "./Edit-Profile-Recruiter.vue?vue&type=script&lang=js&"
export * from "./Edit-Profile-Recruiter.vue?vue&type=script&lang=js&"
import style0 from "./Edit-Profile-Recruiter.vue?vue&type=style&index=0&id=6dd12b13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd12b13",
  null
  
)

export default component.exports